import React, { useState, useRef, useEffect } from 'react';
import firmaImg from '../../../assets/appearance/firma.png';
import { useTranslation } from "react-i18next";
import domtoimage from "dom-to-image";
import { authorize } from "../../../services/authService"; // Asegúrate de ajustar la ruta según sea necesario




const ModalDefinirApariencia = () => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState('optionNinguna');
  const [signatureImage, setSignatureImage] = useState(null);
  const [isItalic, setIsItalic] = useState(false);
  const [alignment, setAlignment] = useState('center');
  const [showName, setShowName] = useState(true);
  const [showDate, setShowDate] = useState(true);
  const [showFreeText, setShowFreeText] = useState(false);
  const [showLabels, setShowLabels] = useState(false);
  const [freeText, setFreeText] = useState('');
  const signatureCanvasRef = useRef(null);
  const [isCanvasEmpty, setIsCanvasEmpty] = useState(false);
  const fileInputRef = useRef(null);
  const container = useRef(null);
  const [showLogo, setShowLogo] = useState(true); // State for the logo checkbox

  const handleLogoToggle = () => {
    setShowLogo(!showLogo);
  };

  // Conditionally add classes based on the logo checkbox state
  const vistaPreviaClassName = `vistaPrevia ${showLogo ? 'firma-apariencia size-pre' : ''}`;

  const getUserName = () => {
    const toProperCase = (name) => {
      if (!name) return "Usuario";
      return name
          .split(/[\s]+/)
          .map(
              (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(' ');
    };

    const userInfo = sessionStorage.getItem('userinfo');
    if (userInfo) {
      const parsedUserInfo = JSON.parse(atob(userInfo));
      return toProperCase(parsedUserInfo.name);
    }
    return 'Usuario';   };

// Ejemplo de uso
  console.log(getUserName());


  const handleAuthorize = () => {
    fillAppearance();
  };
  const fillAppearance = () => {
    const element = container.current;
    element.style.border = 'none';
    element.style.boxShadow = 'none';

    domtoimage.toPng(element)
      .then(function (dataUrl) {
        const img = new Image();
        img.src = dataUrl;
        img.onload = () => {
          const appearance = JSON.parse(localStorage.getItem('appearance'));
          appearance.image.value = dataUrl;
          const x = appearance.location.frame.lowerLeft.x;
          const y = appearance.location.frame.lowerLeft.y;
          appearance.location.frame.upperRight.x = img.width / 2;
          appearance.location.frame.upperRight.y = img.height / 2;
          localStorage.setItem('appearance', JSON.stringify(appearance));
          callSignDocument();
        };
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  }
  const getConfig = () => {
    const configEncoded = sessionStorage.getItem('configs');
    if (configEncoded) {
      const configDecoded = atob(configEncoded); // Decodificar base64
      return JSON.parse(configDecoded); // Parsear a JSON
    }
    return null; // Retorna null si no existe la configuración
  };

  const callSignDocument = async () => {
    const config = getConfig();
    if (config && config.SIGN_AUTH_REQUIRED ) {
      sessionStorage.setItem('sentToSign', 'true');
    }
    try {
      window.location.href = await authorize(
          process.env.REACT_APP_IDPID,
          process.env.REACT_APP_RESPONSE_TYPE,
          process.env.REACT_APP_STATE,
          process.env.REACT_APP_REDIRECT_URI
      );
    } catch (error) {
      console.error('Authorization failed', error);
    }
  }
  const handleOptionChange = (event) => {
    const option = event.target.value;
    setSelectedOption(option);

    if (option === 'optionNombre') {
      setIsItalic(true);
    } else {
      setIsItalic(false);
    }

    if (option === 'optionImg') {
      fileInputRef.current.click();  // Abre automáticamente el explorador de archivos
    }

    if (option === 'optionNinguna') {
      setSignatureImage(null);
      setIsItalic(false);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSignatureImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAlignmentChange = (align) => {
    setAlignment(align);
  };

  const getMousePos = (e) => {
    const canvas = signatureCanvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    return {
      x: (e.clientX - rect.left) * scaleX,
      y: (e.clientY - rect.top) * scaleY,
    };
  };

  const handleMouseDown = (e) => {
    const pos = getMousePos(e);
    const context = signatureCanvasRef.current.getContext('2d');
    context.beginPath();
    context.moveTo(pos.x, pos.y);
  };

  const handleMouseMove = (e) => {
    if (e.buttons !== 1) return;
    const pos = getMousePos(e);
    const context = signatureCanvasRef.current.getContext('2d');
    context.lineTo(pos.x, pos.y);
    context.stroke();
    updateCanvasEmptyState();
  };

  const handleMouseUp = () => {
    const canvas = signatureCanvasRef.current;
    const context = canvas.getContext('2d');
    context.closePath();
    updateCanvasEmptyState(); // Verifica el estado del canvas después de terminar de dibujar
  };

  // Función para verificar si el canvas está vacío
  const updateCanvasEmptyState = () => {
    const canvas = signatureCanvasRef.current;
    const context = canvas.getContext('2d');
    const empty = context.getImageData(0, 0, canvas.width, canvas.height).data.every((value) => value === 0);
    setIsCanvasEmpty(empty);
  };

  // Función para borrar el canvas
  const clearSignatureCanvas = () => {
    const canvas = signatureCanvasRef.current;
    const context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    setIsCanvasEmpty(true); // Marcar el canvas como vacío después de borrarlo
  };

  // Función para guardar la firma como imagen y luego limpiar el canvas
  const saveSignatureCanvas = () => {
    const canvas = signatureCanvasRef.current;
    const imageURL = canvas.toDataURL(); // Convierte el contenido del canvas a una URL de imagen
    setSignatureImage(imageURL); // Guarda la URL de la imagen en el estado para mostrarla en la vista previa
    clearSignatureCanvas(); // Limpia el canvas después de guardar
  };


  useEffect(() => {
    const canvas = signatureCanvasRef.current;
    if (canvas) {
      canvas.width = 600; // Fixed internal width
      canvas.height = 200; // Fixed internal height
      const context = canvas.getContext('2d');
      context.strokeStyle = 'black';
      context.lineWidth = 2;
    }
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = String(today.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <link href="/bootstrap/bootstrap.min.css" rel="stylesheet" />
      <script src="/bootstrap/bootstrap.min.js"></script>

      <div className="component-modal">
        {/* Modal */}
        <div className="modal" id="modalDefinirApariencia">
          <div className="page-container">
            <div className="content-modal">
              {/* Head modal */}
              <div className="header-modal">
                <h2 className="title-modal">DEFINIR APARIENCIA</h2>
                <span className="close-modal">&times;</span>
              </div>

              {/* Body modal */}
              <div className="body-modal">
                <div className="definirApariencia-content">
                  <div className="apariencia-column configSection">
                    <p className="title">CONFIGURACIÓN GRÁFICA</p>
                    <form>
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="radiofirmaManuscrita"
                          type="radio"
                          name="inlineRadioOptions"
                          value="optionfirmaManuscrita"
                          onChange={handleOptionChange}
                        />
                        <label className="form-label" htmlFor="radiofirmaManuscrita">Firma Manuscrita</label>
                      </div>
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="radioImg"
                          type="radio"
                          name="inlineRadioOptions"
                          value="optionImg"
                          onChange={handleOptionChange}
                        />
                        <label className="form-label" htmlFor="radioImg">Imagen</label>
                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={handleImageUpload}
                          style={{ display: 'none' }}
                        />
                      </div>
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="radioNombre"
                          type="radio"
                          name="inlineRadioOptions"
                          value="optionNombre"
                          onChange={handleOptionChange}
                        />
                        <label className="form-label" htmlFor="radioNombre">Nombre (cursiva)</label>
                      </div>
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="radioNinguna"
                          type="radio"
                          name="inlineRadioOptions"
                          value="optionNinguna"
                          checked={selectedOption === 'optionNinguna'}
                          onChange={handleOptionChange}
                        />
                        <label className="form-label" htmlFor="radioNinguna">Ninguna</label>
                      </div>
                      <div className="form-group">
                        <input className="form-checkbox" id="checkbox6" type="checkbox"  onChange={handleLogoToggle}  defaultChecked />
                        <label className="form-label" htmlFor="checkbox6">Logotipo (marca de agua Mi Firma)</label>
                      </div>
                    </form>

                    <p className="title">CONFIGURACIÓN DE TEXTO</p>
                    <div className="text-align">
                      <button
                        className={`btn-small btn-align ${alignment === 'left' ? 'active' : ''}`}
                        type="button"
                        onClick={() => handleAlignmentChange('left')}
                      >
                        <span className="material-symbols-outlined">format_align_left</span>
                      </button>
                      <button
                        className={`btn-small btn-align ${alignment === 'justify' ? 'active' : ''}`}
                        type="button"
                        onClick={() => handleAlignmentChange('justify')}
                      >
                        <span className="material-symbols-outlined">format_align_justify</span>
                      </button>
                      <button
                        className={`btn-small btn-align ${alignment === 'center' ? 'active' : ''}`}
                        type="button"
                        onClick={() => handleAlignmentChange('center')}
                      >
                        <span className="material-symbols-outlined">format_align_center</span>
                      </button>
                      <button
                        className={`btn-small btn-align ${alignment === 'right' ? 'active' : ''}`}
                        type="button"
                        onClick={() => handleAlignmentChange('right')}
                      >
                        <span className="material-symbols-outlined">format_align_right</span>
                      </button>
                    </div>
                    <form>
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="checkbox12"
                          type="checkbox"
                          checked={showName}
                          onChange={() => setShowName(!showName)}
                        />
                        <label className="form-label" htmlFor="checkbox12">Nombre</label>
                      </div>
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="checkbox13"
                          type="checkbox"
                          checked={showDate}
                          onChange={() => setShowDate(!showDate)}
                        />
                        <label className="form-label" htmlFor="checkbox13">Fecha</label>
                      </div>
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="inputtextoLibre"
                          type="checkbox"
                          checked={showFreeText}
                          onChange={() => setShowFreeText(!showFreeText)}
                        />
                        <label className="form-label" htmlFor="inputtextoLibre">Texto Libre</label>
                      </div>
                      {showFreeText && (
                        <div className="form-group textoLibre">
                          <textarea
                            className="form-textarea"
                            id="txtLibre"
                            value={freeText}
                            onChange={(e) => setFreeText(e.target.value)}
                            required
                            rows="3"
                          />
                          <a className="borrar-txt" href="#" onClick={() => setFreeText('')}>Borrar</a>
                        </div>
                      )}
                      <div className="form-group">
                        <input
                          className="form-checkbox"
                          id="checkbox16"
                          type="checkbox"
                          checked={showLabels}
                          onChange={() => setShowLabels(!showLabels)}
                        />
                        <label className="form-label" htmlFor="checkbox16">Etiquetas</label>
                      </div>
                    </form>
                  </div>

                  
                  <div className="wrapper">
                    <div className="item" tabIndex="0">
                      <p className="item-heading" tabIndex="0" >
                        VISTA PREVIA
                      </p>
                      <div id="item" className="item-content" style={{ display: 'block' }}>
                        <div className="apariencia-preview">
                          <div className="a-view">
                            <div ref={container} className="a-content">
                              <div className={vistaPreviaClassName} style={{ textAlign: alignment }}>
                              {signatureImage && (selectedOption === 'optionImg' || selectedOption === 'optionfirmaManuscrita' ) &&  (
                      <img src={signatureImage} alt="Firma" style={{ width: '200px', height: 'auto' }} />
                    )}

                                {showName && (
                                  <div style={{ fontWeight: 'bold', fontStyle: selectedOption === 'optionNombre' && isItalic ? 'italic' : 'normal' }}>
                                    {showLabels ? 'Nombre: ' : ''}{getUserName()}
                                  </div>
                                )}

                                {showDate && (
                                  <div>
                                    {showLabels ? 'Fecha: ' : ''}{getCurrentDate()}
                                  </div>
                                )}

                                {showFreeText && <div>{freeText}</div>}
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    {selectedOption === 'optionfirmaManuscrita' && (
        <div className="content_firma-manustrita" style={{ display: 'block' , maxWidth: '100%', margin: '0 auto', marginTop: '15px' }}>
          <div className="dibujar-firma" style={{textAlign: 'center', margin: '0 0'}}>
            <div
                style={{
                  textAlign:"left",
                  fontSize: '16px',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                  textUnderlineOffset: '3px',
                  textDecorationThickness: '4px',
                  textDecorationColor: '#1E429F', // Mismo color que el botón GUARDAR
                  marginBottom: '15px',
                }}
            >
              DIBUJAR FIRMA
            </div>
            <canvas
                id="signatureCanvas"
                ref={signatureCanvasRef}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                style={{width: '100%', maxWidth: '100%', height: '200px'}}
            ></canvas>
          </div>
          <div className="footer-modal">
            <div className="actions-firma-manuscrita">
              <button className="btn-small btn-secondary modal-trigger" onClick={clearSignatureCanvas}>Borrar</button>
              <button
                  className={`btn-small btn-primary ${isCanvasEmpty ? 'disable-link' : ''}`}
                  onClick={saveSignatureCanvas}
              >
                    GUARDAR
                  </button>
                </div>
              </div>

        </div>
      )}

    </div>
  </div>
</div>

{/* Footer modal */}
<div className="footer-modal">
  <div className="actions">
    <button type="button" className="btn-small btn-secondary modal-trigger" data-dismiss="modal">
      {t('signatureAppearance.cancelar')}
    </button>
    <button type="button" className="btn-small btn-primary" onClick={handleAuthorize}>
      {t('signatureAppearance.accept')}
    </button>
  </div>
</div>
</div>
</div>
</div>
</div>
    </>
  );

};

export default ModalDefinirApariencia;
